import React from "react";

const CommercialActivitiesTab = ({ data }) => {
  return (
    <>
      <div className="wow fadeIn">
        <div dangerouslySetInnerHTML={{ __html: data.body }}></div>
      </div>
    </>
  );
};

export default CommercialActivitiesTab;
